// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3VEK-","notes":"Notes_notes__2HK-3","note":"Notes_note__2h8_8","markdown":"Notes_markdown__2ljZQ"};